import { useState } from "react";

import "./binput.css";
const BasicInput = ({
  type = "text",
  margin,
  className,
  bgcolor,
  bcolor,
  text,
  placeholder,
  textcolor,
  value,
  onChange,
  style,
  textAlign = "left", // prop جدید
  disabled,
}) => {
  const [focused, setFocused] = useState(false);

  return (
    <div className={`m-${margin}  ${className}`}>
      <label
        className={`labelpass ${focused || value ? "floating" : ""} text-${
          disabled ? "secondary" : bcolor
        }`}
        style={{ "--bg": `${bg(bgcolor)}`, "--scolor": `--bs-${bcolor}-rgb` }}
        aria-label={text}
      >
        <input
          className={`inputpass border-${
            disabled ? "secondary" : bcolor
          } text-${textcolor}`}
          type={type}
          name={text}
          placeholder={text}
          style={{ textAlign, ...style }}
          required
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          onChange={(e) => onChange(e.target.value)}
          value={value}
          disabled={disabled}
        />
      </label>
    </div>
  );
};

const bg = (color) => {
  switch (color) {
    case "dark":
      return "#212529";
      break;
    case "white":
      return "#ffffff";
      break;
  }
};
// <BasicInput
//       bsize="2"
//       bcolor="primary"
//       margin="3"
//       bgcolor="white"
//       textcolor="black"
//       scolor="primary"
//       text="Email"
//     />
export default BasicInput;
